import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
import moment from "moment";
import html2pdf from "html2pdf.js";

const FarmerPurchaseList = (props) => {
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteData } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this farmer purchase detail?",
      onOk() {
        setDeleteLoading(true);

        deleteData(
          {
            url: `/api/farmerPurchaseDetail/?orgId=${localStorage.getItem(
              "orgId"
            )}&farmerPurchaseId=${data.farmerPurchaseId}`,
            method: "DELETE",
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
              setDeleteLoading(false);
            }

            if (data.error) {
              toast.error(data.error);
              setDeleteLoading(false);
            }
            FillDetail();
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/farmerPurchaseDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    setLoading(true);
    // console.log(approvalStatus);
    let data = "";
    if (approvalStatus === "approve") {
      data = {
        farmerPurchaseId: selectedApprovalData && selectedApprovalData.farmerPurchaseId,
        approved: 1,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "disapprove") {
      data = {
        farmerPurchaseId: selectedApprovalData && selectedApprovalData.farmerPurchaseId,
        approved: 2,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "sendNextApprove") {
      data = {
        farmerPurchaseId: selectedApprovalData && selectedApprovalData.farmerPurchaseId,
        approved: 0,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 1,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    }

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/approvefarmerPurchase/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        setLoading(false);
        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const viewPdf = (id) => {
    setPdfView(true);

    const Id = id;

    getDetailView(
      {
        url: `/api/farmerPurchaseDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerPurchaseId=${Id}`,
      },
      (res) => {
        setPdfData(res);
      }
    );
  };
  
  const generatePDF = (docNo) => {
    const input = pdfContainerRef.current;

    const pdfName = docNo || "Farmer Purchase";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-1">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Farmer Purchase Detail
            </label>
          </div>

          <div className="col-6 text-right">
         
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  sId(serviceId);
                  addForm(true);
                  props.update(false);
                }}
              >
                Add Farmer Purchase Detail
              </button>
            
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th> Date</th>
                            <th>Doc No</th>
                            <th>Received By</th>
                            <th>Warehosue</th>
                            <th>Market Detail</th>

                            <th>Farmer Name</th>

                            <th>Approval</th>
                            <th>Approved by</th>
                            <th>Delete</th>
                            <th>View</th>
                            <th>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.farmerPurchaseDate}</td>

                                <td>{x.farmerPurchaseNo}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.warehouseName}</td>
                                <td>{x.marketDocNo}</td>
                                <td>{x.farmerName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    // disabled={
                                    //   x.nextlevel == 1
                                    //     ? x.allowApproveUserId == loginUserId
                                    //       ? false
                                    //       : true
                                    //     : x.approved == 0 &&
                                    //       x.reportingId == loginUserId
                                    //     ? false
                                    //     : true
                                    // }

                                    disabled={x.approved == 1 ? true : false}
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                <td>{x.approvedByName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => deleteOperation(e, x)}
                                    disabled={deleteLoading}
                                  >
                                    {deleteLoading ? (
                                      <Spin size="small" />
                                    ) : (
                                      <i className="fa fa-trash"></i>
                                    )}
                                  </button>
                                </td>

                               
                                  <td>
                                    {" "}
                                    <button
                                      className="btn"
                                      onClick={() =>
                                        viewPdf(x.farmerPurchaseId)
                                      }
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                    disabled={x.approved == 1 ? true : false}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Purchase Detail Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
            disabled={loading}
          >
            {loading ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
            disabled={loading}
          >
            {loading ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>

      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <br />
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  localStorage.getItem("organizationIcon")
                                }`}
                                width="50"
                                height="50"
                                alt=""
                              />
                              &nbsp;Farmer Purchase Detail
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-6 invoice-col">
                            From
                            <address>
                              <strong>
                                {localStorage.getItem("organizationName")}
                              </strong>
                              <br />
                              To
                              <strong>
                                <br />
                                {pdfData && pdfData.farmerName}(
                              </strong>
                              {pdfData && pdfData.identificationNo})
                              <br />
                              <b>Doc No ID:</b>{" "}
                              {pdfData && pdfData.farmerPurchaseNo}
                              <br />
                              <b>Crop :</b> {pdfData && pdfData.cropName}
                            </address>
                          </div>
                          {/* /.col */}

                          {/* /.col */}
                          <div className="col-sm-6 invoice-col">
                            <br />
                            <b>Date:</b> {pdfData && pdfData.farmerPurchaseDate}
                            <br />
                            <b>Field Officer :</b>{" "}
                            {pdfData && pdfData.employeeName}
                            <br />
                            <b>Warehouse:</b> {pdfData && pdfData.warehouseName}
                            <br />
                            <b>Market Details No:</b>{" "}
                            {pdfData && pdfData.marketDocNo} <br />
                            <b>Area Name:</b> {pdfData && pdfData.areaName}
                            <br />
                          </div>
                          <div className="col-sm-4 invoice-col"></div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table  table-bordered">
                              <thead style={{ background: "#F0E9EA" }}>
                                <tr>
                                  <th>Sr. No</th>
                                  <th>Bales Number</th>
                                  <th>Tag Serial No</th>

                                  <th>Purchase Grade</th>
                                  <th>Bales Weight(kg)</th>
                                  <th>Price/Kg</th>
                                  <th>Total Amount</th>
                                  <th>Reclass Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.BalesDetail &&
                                  pdfData.BalesDetail.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{itm.balesNo}</td>
                                        <td>{itm.sellingTagSerialNo}</td>
                                        <td>{itm.purchaseGradeName}</td>
                                        <td>{itm.baleWeight}</td>
                                        <td>{itm.price}</td>
                                        <td>{itm.totalBalesAmount}</td>
                                        <td>{itm.reClassGradeName}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <br />
                            <hr />

                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Quantity :
                                    </th>
                                    <td> {pdfData && pdfData.totalWeightQty} &nbsp;Kg</td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Advance Amount:
                                    </th>
                                    <td> {pdfData && pdfData.advanceAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Loan Amount</th>
                                    <td> {pdfData && pdfData.loanAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Balance Amount :</th>
                                    <td> {pdfData && pdfData.balanceAmount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.farmerPurchaseNo)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FarmerPurchaseList;
